import { runWhenOneTrustCategoryActive } from '../onetrust';
import { type AddSnapPixelScript } from './snap-pixel.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Add the Snap Pixel script to the head of the document.
 *
 * The `snaptr` queue is defined right away so early tracking calls are kept,
 * while the Snap library only loads once the visitor allows targeting cookies.
 *
 * @see {@link https://businesshelp.snapchat.com/s/article/pixel-generate-code?language=en_US}
 */
export const addSnapPixelScript: AddSnapPixelScript = () => {
  if (document.querySelector(`script[id="${SNAP_PIXEL_SCRIPT_ID}"]`)) return;

  const script = document.createElement('script');

  script.id = SNAP_PIXEL_SCRIPT_ID;
  script.append(document.createTextNode(SNAP_PIXEL_SCRIPT));

  document.head.append(script);

  runWhenOneTrustCategoryActive({ category: 'C0004', callback: addSnapPixelLibraryScript });
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function addSnapPixelLibraryScript() {
  const script = document.createElement('script');

  script.async = true;
  script.src = SNAP_PIXEL_LIBRARY_URL;

  document.head.append(script);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const SNAP_PIXEL_SCRIPT_ID = 'snap-pixel-script';

const SNAP_PIXEL_LIBRARY_URL = 'https://sc-static.net/scevent.min.js';

const SNAP_PIXEL_SCRIPT = `(function(e){if(e.snaptr)return;var a=e.snaptr=function()
{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
a.queue=[];})(window);`;
